import styled from "styled-components";
import { Button } from "../../atoms/Button";
import { CardTemplate } from "../../templates/CardTemplate";
import { useSmsSendComplete } from "./hook";

export const SmsSendCompletePage: React.FC = () => {
  const { maskedPhoneNumber, handleSmsSendComplete } = useSmsSendComplete();

  return (
    <CardTemplate title="SMS送信完了">
      <StyledDescriptionContainer>
        <StyledTextContainer>
          下記の電話番号に認証番号を送信しました。SMS認証へお進みください。
        </StyledTextContainer>

        <StyledPhoneNumberContainer>
          <StyledTextContainer>電話番号</StyledTextContainer>

          <StyledPhoneNumberText>{maskedPhoneNumber}</StyledPhoneNumberText>
        </StyledPhoneNumberContainer>
      </StyledDescriptionContainer>

      <Button
        text="次へ"
        variant="filled"
        onClick={handleSmsSendComplete}
        fullWidth
      />
    </CardTemplate>
  );
};

const StyledDescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
`;

const StyledTextContainer = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
`;

const StyledPhoneNumberContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 260px;
  height: 30px;
`;

const StyledPhoneNumberText = styled.div`
  font-size: 20px;
  font-weight: 400;
  line-height: 150%;
`;
